// extracted by mini-css-extract-plugin
export default {"root":"app-react-portainer-gitops-ComposePathField-PathSelector-module__root"};